module.exports = __webpack_public_path__ + "img/sword_in_the_hat.2be1a20b.jpg";